import React from 'react'
import Card from '../../components/card'
import { withRouter } from 'react-router-dom'

import { AuthContext } from '../../main/authProvider'
import TransactionService from '../../app/service/estoque/transactionService'
import GeneralServices from '../../app/service/generalServices'
import ProgressService from '../../app/service/progressService'
// import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import ConstantsUtil from '../../context/constantsUtil'
import { Button } from 'primereact/button'
import ConfiguracaoEmpresaService from '../../app/service/configuracaoEmpresaService'
import HandleErrorService from '../../app/service/handleErrorService'
import NFseTable from '../../components/nfse/nfseTable'
import * as popUp from '../../components/toastr'
import FornecedorService from '../../app/service/contasAPagar/fornecedorService'
import AuthService from '../../app/service/authService'
import NfseService from '../../app/service/nfse/NfseService'
import CadastrarNfseButtonComponent from '../../components/nfse/cadastrarNfseButtonComponent'

class ValidacaoNFsServico extends React.Component {

    constructor(){
        super();
        this.generalServices = new GeneralServices();
        this.progressService = new ProgressService();
        this.transactionService = new TransactionService();
        this.NfseService = new NfseService()
        this.fornecedorService = new FornecedorService()
        this.configuracaoEmpresaService = new ConfiguracaoEmpresaService();
        this.cadastrarNFSeButtonRef = React.createRef();
    
    }

    state = {
        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',
        
        habilitaBusca: true,

    }

    componentDidMount(){
        // this.checaConfigucarao()
        this.autoSearch()
    }

    autoSearch = async () => {
        await this.generalServices.sleep(100)
        this.search()
    }

    search = () => {
        this.setState({habilitaBusca: false})
    }

    render() {

        const renderTable = () => {
            if(!this.state.habilitaBusca){
                return (
                    <NFseTable
                        validateNFs
                    />
                )
            }
        }

        const renderCriarNFSeButton = () => {
            return (
                <CadastrarNfseButtonComponent
                />
            )
        }

        return (
                   
            <div className="bs-docs-section" >
                
                <Card
                    title = {"Validação das NFs de Serviço"}
                    rightComponent={renderCriarNFSeButton()}
                >

                    {renderTable()}

                </Card>

                <div className="d-flex "/>
            </div>
              
        )
    }


}

ValidacaoNFsServico.contextType = AuthContext

export default withRouter(ValidacaoNFsServico)